<div class="row block-title">
  <div class="col-8 pl-0 title"><span><svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <title>c-warning</title>
        <desc>Created with Sketch.</desc>
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="UI-Dashboard-+-Calendar-02" transform="translate(-165.000000, -984.000000)" fill="#162C4B" fill-rule="nonzero">
            <g id="Vos-rapports" transform="translate(165.000000, 980.000000)">
              <g id="Title">
                <g id="c-warning" transform="translate(0.000000, 4.000000)">
                  <g id="chart-bar-32">
                    <path d="M9,0 L7,0 C6.4,0 6,0.4 6,1 L6,15 C6,15.6 6.4,16 7,16 L9,16 C9.6,16 10,15.6 10,15 L10,1 C10,0.4 9.6,0 9,0 Z" id="Path"></path>
                    <path d="M3,3 L1,3 C0.4,3 0,3.4 0,4 L0,15 C0,15.6 0.4,16 1,16 L3,16 C3.6,16 4,15.6 4,15 L4,4 C4,3.4 3.6,3 3,3 Z" id="Path"></path>
                    <path d="M15,7 L13,7 C12.4,7 12,7.4 12,8 L12,15 C12,15.6 12.4,16 13,16 L15,16 C15.6,16 16,15.6 16,15 L16,8 C16,7.4 15.6,7 15,7 Z" id="Path"></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg></span> <span i18n="reports-stats|@@today">Vos rapports</span></div>
  <div class="col-4 pr-0 date-range"><span><svg width="12px" height="7px" viewBox="0 0 12 7" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <title>priority-low</title>
        <desc>Created with Sketch.</desc>
        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="UI-Dashboard-+-Calendar-02" transform="translate(-1049.000000, -174.000000)" fill="#919396" fill-rule="nonzero">
            <g id="Select" transform="translate(895.000000, 155.000000)">
              <g id="Group-4-Copy">
                <g id="priority-low" transform="translate(154.000000, 19.000000)">
                  <path d="M10.3814405,0.586 L6,5.15976904 L1.61855948,0.586 L0.586,1.6638849 L5.48372026,6.7765964 C5.7688789,7.07418253 6.2311211,7.07418253 6.51627974,6.7765964 L11.414,1.6638849 L10.3814405,0.586 Z" id="Path"></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg></span> <span i18n="reports-stats|@@today">Aujourd'hui</span></div>
</div>
<div class="row block-body">
  <div class="col-12">
    <div class="indicator-wrapper">
      <p class="indicator-value">256</p>
      <p class="indicator-description" i18n="reports-stats|@@reports_loading">Rapports en cours</p>
    </div>
    <div class="indicator-wrapper">
      <p class="indicator-value" i18n="reports-stats|@@time">1min 30s</p>
      <p class="indicator-description" i18n="reports-stats|@@avarage_edition_time">Temps par édition moyen</p>
      <p class="indicator-trend negative"><svg width="16px" height="8px" viewBox="0 0 16 8" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <title>trend</title>
          <desc>Created with Sketch.</desc>
          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
            <g id="UI-Dashboard-+-Calendar-02" id="global-form-svg" transform="translate(-397.000000, -1345.000000)">
              <g id="Vos-rapports" transform="translate(165.000000, 980.000000)">
                <g id="Rapport" transform="translate(0.000000, 48.000000)">
                  <g id="Group-5-Copy-2" transform="translate(155.000000, 198.000000)">
                    <g id="Group-4">
                      <g id="Group-2" transform="translate(77.000000, 113.000000)">
                        <g id="trend-up" transform="translate(8.000000, 10.000000) scale(1, -1) translate(-8.000000, -10.000000) translate(0.000000, 6.000000)">
                          <polyline id="Path" points="15.5 0.5 8.5 7.5 4.5 3.5 0.5 7.5"></polyline>
                          <polyline id="Path" points="9.5 0.5 15.5 0.5 15.5 6.5"></polyline>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg> -1,5%</p>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/stats/reports-stats/reports-stats.component.html